/**
 * UX Animations - LP Seabra
 * Controllers JavaScript para micro-interacoes
 *
 * Usa IntersectionObserver nativo (sem dependencias)
 */

(function() {
  'use strict';

  // ============================================
  // CONFIGURACAO
  // ============================================
  const CONFIG = {
    revealThreshold: 0.15,
    revealRootMargin: '0px 0px -50px 0px',
    blurScrollThreshold: 100,
    flyToCartDuration: 700,
    buttonSuccessDuration: 1500
  };

  // Verificar preferencias do usuario
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    document.documentElement.classList.add('reduce-motion');
    console.log('[UX] Reduced motion enabled - animations disabled');
    return;
  }

  // ============================================
  // SCROLL REVEAL
  // ============================================
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('[data-reveal], [data-reveal-stagger]');

    if (!revealElements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: CONFIG.revealThreshold,
      rootMargin: CONFIG.revealRootMargin
    });

    revealElements.forEach(el => observer.observe(el));

    console.log(`[UX] Scroll reveal initialized for ${revealElements.length} elements`);
  }

  // ============================================
  // BLUR ON SCROLL (Collection Hero)
  // ============================================
  function initBlurOnScroll() {
    const heroes = document.querySelectorAll('.collection-hero, .collection-banner, .page-header');

    if (!heroes.length) return;

    let ticking = false;

    function updateBlur() {
      const scrolled = window.scrollY > CONFIG.blurScrollThreshold;
      heroes.forEach(hero => {
        hero.classList.toggle('is-scrolled', scrolled);
      });
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateBlur);
        ticking = true;
      }
    }, { passive: true });

    console.log('[UX] Blur on scroll initialized');
  }

  // ============================================
  // FLY TO CART
  // ============================================
  function initFlyToCart() {
    // Selecionar botoes de adicionar ao carrinho
    const addToCartBtns = document.querySelectorAll(
      '.btn-primary-mega, ' +
      '.product-form__submit, ' +
      '.product-form__add-button, ' +
      '[name="add"], ' +
      '.add-to-cart-button'
    );

    // Selecionar icone do carrinho
    const cartIcon = document.querySelector(
      '.header__cart-count, ' +
      '.cart-count-bubble, ' +
      '[aria-label*="Cart"], ' +
      '.header__icon--cart, ' +
      '.site-header__cart'
    );

    if (!addToCartBtns.length) return;

    addToCartBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        // Encontrar imagem do produto
        const productImage = document.querySelector(
          '.gallery-main img, ' +
          '.product__media-item img, ' +
          '.product__media img, ' +
          '.product-single__photo img'
        );

        // Se nao encontrar imagem, apenas fazer loading state
        if (!productImage || !cartIcon) {
          handleButtonStates(btn);
          return;
        }

        // Criar elemento fly
        const fly = document.createElement('div');
        fly.className = 'fly-to-cart';
        fly.style.backgroundImage = `url(${productImage.src})`;

        // Posicionar no centro da imagem
        const imgRect = productImage.getBoundingClientRect();
        const cartRect = cartIcon.getBoundingClientRect();

        fly.style.left = `${imgRect.left + imgRect.width / 2 - 25}px`;
        fly.style.top = `${imgRect.top + imgRect.height / 2 - 25}px`;

        document.body.appendChild(fly);

        // Trigger reflow
        fly.offsetHeight;

        // Animar para o carrinho
        fly.classList.add('is-animating');
        fly.style.left = `${cartRect.left + cartRect.width / 2 - 25}px`;
        fly.style.top = `${cartRect.top + cartRect.height / 2 - 25}px`;

        // Bump no icone do carrinho
        setTimeout(() => {
          cartIcon.classList.add('is-bumping');
          setTimeout(() => cartIcon.classList.remove('is-bumping'), 400);
        }, CONFIG.flyToCartDuration - 100);

        // Remover elemento apos animacao
        setTimeout(() => fly.remove(), CONFIG.flyToCartDuration);

        // Button states
        handleButtonStates(btn);
      });
    });

    console.log(`[UX] Fly to cart initialized for ${addToCartBtns.length} buttons`);
  }

  // ============================================
  // BUTTON STATES (Loading/Success)
  // ============================================
  function handleButtonStates(btn) {
    // Salvar texto original
    const originalText = btn.textContent;

    // Loading state
    btn.classList.add('is-loading');

    // Success state apos delay (simulando request)
    setTimeout(() => {
      btn.classList.remove('is-loading');
      btn.classList.add('is-success');

      // Voltar ao normal
      setTimeout(() => {
        btn.classList.remove('is-success');
      }, CONFIG.buttonSuccessDuration);
    }, 800);
  }

  // ============================================
  // QUANTITY FEEDBACK
  // ============================================
  function initQuantityFeedback() {
    const qtyInputs = document.querySelectorAll(
      '.quantity-selector__input, ' +
      '.quantity__input, ' +
      '.js-qty-input, ' +
      'input[name="quantity"]'
    );

    qtyInputs.forEach(input => {
      // Listener para change
      input.addEventListener('change', () => {
        input.classList.add('is-changing');
        setTimeout(() => input.classList.remove('is-changing'), 250);
      });

      // Listener para input (digitacao)
      input.addEventListener('input', () => {
        input.classList.add('is-changing');
        setTimeout(() => input.classList.remove('is-changing'), 250);
      });
    });

    // Botoes de quantidade
    const qtyButtons = document.querySelectorAll(
      '.quantity-selector__button, ' +
      '.quantity__button, ' +
      '.js-qty-button'
    );

    qtyButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.parentElement.querySelector('input');
        if (input) {
          setTimeout(() => {
            input.classList.add('is-changing');
            setTimeout(() => input.classList.remove('is-changing'), 250);
          }, 50);
        }
      });
    });

    console.log(`[UX] Quantity feedback initialized`);
  }

  // ============================================
  // HERO PARALLAX
  // ============================================
  function initHeroParallax() {
    const heroImages = document.querySelectorAll(
      '.hero-banner__image, ' +
      '.slideshow__image, ' +
      '.banner__media img'
    );

    if (!heroImages.length) return;

    let ticking = false;

    function updateParallax() {
      const scrollY = window.scrollY;

      // So aplicar parallax enquanto hero esta visivel
      if (scrollY < window.innerHeight) {
        heroImages.forEach(img => {
          img.style.transform = `translateY(${scrollY * 0.25}px)`;
        });
      }

      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });

    console.log('[UX] Hero parallax initialized');
  }

  // ============================================
  // CART ITEM REMOVE ANIMATION
  // ============================================
  function initCartRemoveAnimation() {
    document.addEventListener('click', (e) => {
      const removeBtn = e.target.closest(
        '.line-item__remove-button, ' +
        '.cart-item__remove, ' +
        '.cart__remove, ' +
        '[data-cart-remove]'
      );

      if (!removeBtn) return;

      const lineItem = removeBtn.closest('.line-item, .cart-item, .cart__item');

      if (lineItem) {
        e.preventDefault();
        lineItem.classList.add('is-removing');

        // Aguardar animacao antes de remover
        setTimeout(() => {
          // Se tiver href, navegar
          if (removeBtn.href) {
            window.location.href = removeBtn.href;
          }
          // Se for form, submeter
          else if (removeBtn.form) {
            removeBtn.form.submit();
          }
          // Se tiver data attribute, disparar evento
          else {
            removeBtn.click();
          }
        }, 350);
      }
    });

    console.log('[UX] Cart remove animation initialized');
  }

  // ============================================
  // GALLERY TRANSITION
  // ============================================
  function initGalleryTransition() {
    const thumbs = document.querySelectorAll(
      '.gallery-thumb, ' +
      '.thumbnail, ' +
      '.product__media-toggle'
    );

    const mainGallery = document.querySelector(
      '.gallery-main, ' +
      '.product__media-wrapper'
    );

    if (!thumbs.length || !mainGallery) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        mainGallery.classList.add('is-transitioning');
        setTimeout(() => {
          mainGallery.classList.remove('is-transitioning');
        }, 250);
      });
    });

    console.log('[UX] Gallery transition initialized');
  }

  // ============================================
  // TRUST BAR REVEAL
  // ============================================
  function initTrustBarReveal() {
    const trustBars = document.querySelectorAll('.trust-bar, .trust-badges');

    if (!trustBars.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.3
    });

    trustBars.forEach(bar => observer.observe(bar));

    console.log('[UX] Trust bar reveal initialized');
  }

  // ============================================
  // AUTO ADD DATA-REVEAL
  // ============================================
  function autoAddRevealAttributes() {
    // Secoes que devem ter reveal automatico
    const sectionsToReveal = [
      '.featured-collection',
      '.collection-list',
      '.rich-text',
      '.image-with-text',
      '.multicolumn',
      '.newsletter',
      '.trust-bar',
      '.reviews-section',
      '.faq-section',
      '.product-recommendations',
      '.related-products'
    ];

    sectionsToReveal.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        if (!el.hasAttribute('data-reveal')) {
          el.setAttribute('data-reveal', '');
        }
      });
    });

    // Grids de produtos devem ter stagger
    const productGrids = document.querySelectorAll(
      '.product-list__inner, ' +
      '.collection-product-list, ' +
      '.product-grid, ' +
      '.grid--uniform'
    );

    productGrids.forEach(grid => {
      if (!grid.hasAttribute('data-reveal-stagger')) {
        grid.setAttribute('data-reveal-stagger', '');
      }
    });

    console.log('[UX] Auto-added reveal attributes');
  }

  // ============================================
  // INIT ALL
  // ============================================
  function init() {
    console.log('[UX] Initializing animations...');

    // Auto-adicionar atributos
    autoAddRevealAttributes();

    // Inicializar todos os modulos
    initScrollReveal();
    initBlurOnScroll();
    initFlyToCart();
    initQuantityFeedback();
    initHeroParallax();
    initCartRemoveAnimation();
    initGalleryTransition();
    initTrustBarReveal();

    console.log('[UX] All animations initialized!');
  }

  // ============================================
  // START
  // ============================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expor para debug
  window.UXAnimations = {
    init,
    initScrollReveal,
    initFlyToCart,
    CONFIG
  };

})();
